import { DataGrid } from './DataGrid';
import { GridSelection } from './GridSelection';

export type RowKeySelectionData = {
  [key: string]: boolean;
};

export class RowKeyedGridSelection implements GridSelection {
  private selectionData: RowKeySelectionData;

  constructor(selectionData?: RowKeySelectionData) {
    this.selectionData = selectionData || {};
  }

  public clearSelection(): void {
    this.selectionData = {};
  }

  public isSelected(cell: DataGrid.Cell): boolean {
    return !!cell.rowKey && this.selectionData[cell.rowKey];
  }

  public toggleRowSelect(rowKey: string, select?: boolean): void {
    if (!rowKey) { throw new Error("rowKey must be defined"); }

    if (select === null || select === undefined) {
      select = !this.selectionData[rowKey];
    }

    // wondering if we should `delete` in the !select case... --ckovatch
    this.selectionData[rowKey] = select;
  }
}
